import React from 'react';
import PropTypes from 'prop-types';
import { SFUpcomingAppt, SFNotification } from 'utils/types';
import css from './UpcomingItem.scss';
import Location from './UpcomingLocation';
import Instructions from './UpcomingInstructions';
import Course from './UpcomingCourse';
import Time from './UpcomingTime';
import Owner from './UpcomingOwner';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';

export default class UpcomingItem extends React.Component {

  get course() {
    return isEmpty(this.props.courseContext) || isEmpty(this.props.courseContext.name)
      ? null
      : <Course name={this.props.courseContext.name} />;
  }

  get instructions() {
    return isEmpty(this.props.scheduleBlock) || isEmpty(this.props.scheduleBlock.instructions)
      ? null
      : <Instructions instructions={this.props.scheduleBlock.instructions} />
  }

  render() {
    return (
      <div className={css['container']} data-role="upcomingAppointmentCard">
        <Link to={`/appointment/${this.props.id}`} className={css['main']}>
          <Owner
            name={this.props.owner.name}
            title={this.props.owner.title}
            roles={this.props.owner.roles}
            id={this.props.owner.id}
            uuid={this.props.owner.uuid}
            photoAvailable={this.props.owner.photoAvailable}
            appointmentId={this.props.id}
          />
          <Time
            startDate={this.props.startDate}
            duration={this.props.duration}
            timeZone={this.props.timeZone}
          />
          <Location name={this.props.location.name} instructions={this.props.location.instructions} />
          {this.course}
          {this.instructions}
        </Link>
        <Footer
          ownerName={this.props.owner.name}
          startDate={this.props.startDate}
          appointmentId={this.props.id}
          timeZone={this.props.timeZone}
          getAppointments={this.props.getAppointments}
          notification={this.props.notification}
          recurring={this.props.recurring}
        />
      </div>
    );
  }
}

UpcomingItem.propTypes = {
  getAppointments: PropTypes.func.isRequired,
  notification: SFNotification.isRequired,
  timeZone: PropTypes.string,
  ...SFUpcomingAppt
};
